import React, { Component, PropTypes } from 'react'
import { formatTime } from 'common/utils'
import styles from './index.css'

const ERROR_MESSAGE = {
  1: '请求资源被终止',   // MEDIA_ERR_ABORTED
  2: '网络异常',        // MEDIA_ERR_NETWORK
  3: '解码出错',        // MEDIA_ERR_DECODE
  4: '无效资源'         // MEDIA_ERR_SRC_NOT_SUPPORTED
}

export default class Audio extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    duration: PropTypes.number
  }

  constructor (props) {
    super(props)

    this.state = {
      current: 0,
      buffered: 0,
      duration: 0,
      playing: false,
      enable: false,
      message: 'loading...'
    }

    this.progressElement = null

    this.audio = new window.Audio(this.props.src)
    this.audio.volume = 0.5
    this.audio.onloadeddata = this.handleLoadedData.bind(this)
    this.audio.ondurationchange = this.handleDurationChange.bind(this)
    this.audio.onprogress = this.handleProgress.bind(this)
    this.audio.ontimeupdate = this.handleTimeUpdate.bind(this)
    this.audio.onplaying = this.handlePlaying.bind(this)
    this.audio.onpause = this.handlePause.bind(this)
    this.audio.onended = this.handleEnded.bind(this)
    this.audio.onerror = this.handleError.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    // src 改变时重载
    if (nextProps.src !== this.props.src) {
      this.setState({
        current: 0,
        buffered: 0,
        duration: 0,
        playing: false,
        enable: false,
        message: 'loading...'
      })
      this.audio.src = nextProps.src
    }
  }

  componentWillUnmount () {
    this.audio.onloadeddata = null
    this.audio.ondurationchange = null
    this.audio.onprogress = null
    this.audio.ontimeupdate = null
    this.audio.onplaying = null
    this.audio.onpause = null
    this.audio.onended = null
    this.audio.onerror = null

    this.audio.src = ''

    delete this.audio
  }

  bufferedPercent () {
    const { buffered, duration } = this.state

    return duration > 0 ? `${(buffered / duration * 100).toFixed(2)}%` : 0
  }

  currentPercent () {
    const { current, duration } = this.state

    return duration > 0 ? `${(current / duration * 100).toFixed(2)}%` : 0
  }

  handleLoadedData () {
    this.setState({ enable: true, message: '' })
  }

  handleDurationChange () {
    const duration = this.props.duration
                   ? Math.floor(this.props.duration)
                   : Math.floor(this.audio.duration)

    this.setState({ duration })
  }

  handleProgress () {
    const { buffered } = this.audio

    if (buffered.length === 1 && buffered.start(0) === 0) {
      this.setState({ buffered: Math.floor(buffered.end(0)) })
    }
  }

  handleTimeUpdate () {
    this.setState({ current: Math.floor(this.audio.currentTime) })
  }

  handlePlaying () {
    this.setState({ playing: true })
  }

  handlePause () {
    this.setState({ playing: false })
  }

  handleEnded () {
    this.setState({ playing: false })
  }

  handleError () {
    this.setState({ enable: false, message: ERROR_MESSAGE[this.audio.error.code] || '未知错误' })
  }

  handleClickControlButton () {
    if (this.state.playing) {
      this.audio.pause()
    } else {
      this.audio.play()
    }
  }

  handleClickProgress (ev) {
    const { duration } = this.state
    const seekTo = Math.floor(ev.nativeEvent.offsetX / this.progressElement.clientWidth * duration)

    this.audio.currentTime = seekTo
  }

  render () {
    return (
      <div className={ styles.root }>
        { this.state.enable ? null : <div className={ styles.enable }>{ this.state.message }</div> }
        <div className={ styles.wrap }>
          <div className={ styles.controlButton } onClick={ () => this.handleClickControlButton() }>
            { this.state.playing ? <div className={ styles.pause }></div> : <div className={ styles.play }></div> }
          </div>
          <div className={ styles.info }>
            <div className={ styles.time }>{ formatTime(this.state.current) }</div>
            <div className={ styles.progress } ref={ el => this.progressElement = el } onClick={ ev => this.handleClickProgress(ev) }>
              <div className={ styles.buffered } style={{ width: this.bufferedPercent() }}></div>
              <div className={ styles.played } style={{ width: this.currentPercent() }}></div>
            </div>
            { this.state.duration === Infinity ? null : <div className={ styles.time }>{ formatTime(this.state.duration) }</div> }
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Audio/index.js
 **/